
export const SVIECKY = ["KAH1", "KAH2", "S1"];

export const ORNAMENT_TAB_NO = 4;
export const DECEASED_TAB_NO = 1;
export const CHRONICLE_TAB_NO = 6;

export const ARROW_DELAY = 500;
export const MAP_MOVEMENT_SPEED = 40;
export const MAP_MOVEMENT_STEP = 200;

export const ORNAMENT_POLLING_INTERVAL = 60000;
export const ORNAMENT_BASELINE_SIZE = 50;

export const MOUSE_OVER_DEBOUNCE = 300;

export const CLICKABLE_LAYER_ID = "clickableAreas";
export const POPUPS_ENABLED_ID = "popupsEnabled";